import { Redline } from 'redline-client-sdk';
import { RLDebtsEvents } from '../types';
import { pixel } from "../../pixel"

export const debtsEvents = (rl: Redline): RLDebtsEvents => ({
  debtLocated: (payload = {}) => {
    const event = 'debts.DebtLocated.v1';
    rl.track(event, {...payload });
    pixel(event, {...payload})
  },
  debtSimulated: (payload = {}) => {
    const event = 'debts.DebtSimulated.v1';
    rl.track(event, {...payload });
    pixel(event, {...payload})
  },
  debtViewed: (payload = {}) => {
    const event = 'debts.DebtViewed.v1';
    rl.track(event, {...payload });
    pixel(event, {...payload})
  },
  debtClicked: (payload = {}) => {
    const event = 'debts.DebtClicked.v1';
    rl.track(event, {...payload });
    pixel(event, {...payload})
  },
});
